import Form from 'components/Form';
import { IFormValues } from 'routes/Main/type';

import { Grid, Stack, Typography } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
}

const ReasoneVV = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <>
      <RowContainer xs={12}>
        <RowContent title="" titleRatio={0} childrenRatio={12}>
          <Stack
            direction="column"
            sx={{
              border: '1px solid #c0bebed4',
              borderRadius: '7px',
              marginTop: '-20px',
              padding: '8px',
            }}
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
              나. VV ECMO
            </Typography>
            <Grid item flex={1}>
              <Form.MuiRadioGroup
                i18nKey="ECMO.VVECMO"
                values={[1, 2, 3, 4, 5]}
                disabled={disabled}
                defaultValue={getValues('reason_vv_ecmo')}
                onChange={v => setValue('reason_vv_ecmo', v)}
                width="auto"
                direction="column"
              />
            </Grid>
          </Stack>
        </RowContent>
      </RowContainer>
    </>
  );
};

export default ReasoneVV;
